import { createRuleTableIntegrationAdapter } from "../executableFamilies/ruleTable/RuleTableIntegrationAdapter";
import { createTextMergeIntegrationAdapter } from "../executableFamilies/textMerge/TextMergeIntegrationAdapter";
import { createValueTableIntegrationAdapter } from "../executableFamilies/valueTable/ValueTableIntegrationAdapter";
import type {
    RuleIntegrationRegistry,
    RuleIntegrationRuntimeSamples,
} from "../ruleIntegrationTypes";
import {
    CF014_RULE_ID,
    CF014_RULE_TABLE_POLICY,
    CF014_RUNTIME_SAMPLES,
    WF009_RULE_ID,
    WF009_RULE_TABLE_POLICY,
    WF009_RUNTIME_SAMPLES,
    WF010_RULE_ID,
    WF010_RULE_TABLE_POLICY,
    WF010_RUNTIME_SAMPLES,
    WF011_RULE_ID,
    WF011_RULE_TABLE_POLICY,
    WF011_RUNTIME_SAMPLES,
    WF012_RULE_ID,
    WF012_RULE_TABLE_POLICY,
    WF012_RUNTIME_SAMPLES,
} from "./ruleTables/catalogDecisionRuleTablePolicy";
import {
    TR008_RULE_ID,
    TR008_RULE_TABLE_POLICY,
    TR008_RUNTIME_SAMPLES,
} from "./ruleTables/tr008PriceToleranceRuleTablePolicy";
import {
    TR006_RULE_ID,
    TR006_RUNTIME_SAMPLES,
    TR006_TEXT_MERGE_POLICY,
} from "./textMergeRules/tr006ErpDescriptionTextMergePolicy";
import {
    TR007_RULE_ID,
    TR007_RUNTIME_SAMPLES,
    TR007_TEXT_MERGE_POLICY,
} from "./textMergeRules/tr007CrmProductNameTextMergePolicy";
import {
    TR005_RULE_ID,
    TR005_RUNTIME_SAMPLES,
    TR005_VALUE_TABLE_POLICY,
} from "./valueTables/tr005TaxonomyValueTablePolicy";

export {
    CF014_RULE_ID,
    CF014_RUNTIME_SAMPLES,
    TR005_RULE_ID,
    TR005_RUNTIME_SAMPLES,
    TR006_RULE_ID,
    TR006_RUNTIME_SAMPLES,
    TR007_RULE_ID,
    TR007_RUNTIME_SAMPLES,
    TR008_RULE_ID,
    TR008_RUNTIME_SAMPLES,
    WF009_RULE_ID,
    WF009_RUNTIME_SAMPLES,
    WF010_RULE_ID,
    WF010_RUNTIME_SAMPLES,
    WF011_RULE_ID,
    WF011_RUNTIME_SAMPLES,
    WF012_RULE_ID,
    WF012_RUNTIME_SAMPLES,
};

export const TABLE_TEXT_RULE_RUNTIME_SAMPLES: RuleIntegrationRuntimeSamples = {
    [WF009_RULE_ID]: WF009_RUNTIME_SAMPLES,
    [WF010_RULE_ID]: WF010_RUNTIME_SAMPLES,
    [WF011_RULE_ID]: WF011_RUNTIME_SAMPLES,
    [WF012_RULE_ID]: WF012_RUNTIME_SAMPLES,
    [TR005_RULE_ID]: TR005_RUNTIME_SAMPLES,
    [TR006_RULE_ID]: TR006_RUNTIME_SAMPLES,
    [TR007_RULE_ID]: TR007_RUNTIME_SAMPLES,
    [TR008_RULE_ID]: TR008_RUNTIME_SAMPLES,
    [CF014_RULE_ID]: CF014_RUNTIME_SAMPLES,
};

export const TABLE_TEXT_RULE_ADAPTER_REGISTRY: RuleIntegrationRegistry = {
    [WF009_RULE_ID]: createRuleTableIntegrationAdapter(WF009_RULE_TABLE_POLICY),
    [WF010_RULE_ID]: createRuleTableIntegrationAdapter(WF010_RULE_TABLE_POLICY),
    [WF011_RULE_ID]: createRuleTableIntegrationAdapter(WF011_RULE_TABLE_POLICY),
    [WF012_RULE_ID]: createRuleTableIntegrationAdapter(WF012_RULE_TABLE_POLICY),
    [TR005_RULE_ID]: createValueTableIntegrationAdapter(TR005_VALUE_TABLE_POLICY),
    [TR006_RULE_ID]: createTextMergeIntegrationAdapter(TR006_TEXT_MERGE_POLICY),
    [TR007_RULE_ID]: createTextMergeIntegrationAdapter(TR007_TEXT_MERGE_POLICY),
    [TR008_RULE_ID]: createRuleTableIntegrationAdapter(TR008_RULE_TABLE_POLICY),
    [CF014_RULE_ID]: createRuleTableIntegrationAdapter(CF014_RULE_TABLE_POLICY),
};

export const getTableTextRuleIntegrationAdapter = (ruleId: string) =>
    TABLE_TEXT_RULE_ADAPTER_REGISTRY[ruleId];

export const getRegisteredTableTextRuleIntegrationAdapters = (): RuleIntegrationRegistry =>
    TABLE_TEXT_RULE_ADAPTER_REGISTRY;
